import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import { api, INTERN } from "../data";
import { StartLaden } from "../components/Ladeschirm";
import { internZielAufHost, istInternHost, istInternPfad } from "../lib/bereich";

/**
 * Wechsel zwischen Kundenportal und internem Bereich (lib/bereich.ts): Der Supabase-Anschluss (und damit die Sitzung) steht
 * beim Laden der Seite fest. Führt ein Weg innerhalb der App in den jeweils anderen Bereich, lädt die Seite neu, damit dort der
 * passende Anschluss gilt; so arbeitet nie eine Seite des Kundenportals mit der internen Sitzung oder umgekehrt.
 * Auf dem Host intern.… gibt es nur den internen Bereich: „/“ ist /intern, /anmelden ist /intern/anmelden.
 */
export function BereichWaechter() {
  const { pathname, search, hash } = useLocation();
  const intern = istInternPfad(pathname);
  const host = typeof window !== "undefined" && istInternHost(window.location.hostname);
  // Demo im Browser: ein Anschluss für alles (Neuladen setzte die Demo zurück)
  const wechsel = !host && api.mode === "supabase" && intern !== INTERN;
  useEffect(() => {
    if (wechsel) window.location.replace(`${pathname}${search}${hash}`);
  }, [wechsel, pathname, search, hash]);
  if (host && !intern) return <Navigate to={`${internZielAufHost(pathname)}${pathname === "/" ? search : ""}`} replace />;
  if (wechsel) return <StartLaden />;
  return <Outlet />;
}
